module.exports = __webpack_public_path__ + "img/icon-invest2.20945c9e.svg";